// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"71db9b9c","220":"78f2f39b","420":"f801d561","453":"ed3810f9","596":"759137eb","830":"f8b4a809","981":"2424230b"}[chunkId] + ".chunk.js";
};